<template>
    <div class="page-support">

        <div class="block-head">
            <div class="block-head__left">
                <p class="head-title">{{__('Your support tickets')}}</p>
                <p class="desc">{{__('Analytics of all your data')}}</p>
            </div>

            <div class="block-head__right">
                <v-btn class="btn-site" v-on:click="dialog= true">
                    <img src="/dist/images/plus-n.svg" alt="">
                    {{__('New ticket')}}
                </v-btn>
            </div>
        </div>

        <div v-if="tickets" class="list-wrapper">
            <div v-if="tickets.data.length">
                <ItemTicket v-for="(item, key) in tickets.data" :key="key" :item="item" :module="$route.name"/>
            </div>

            <div class="block-no-result" v-else>
                <svg width="100" height="100" viewBox="0 0 160 160" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M80 146.667H113.333C133.333 146.667 146.667 133.333 146.667 113.333V79.9998C146.667 61.9998 135.333 48.6665 118.667 46.6665C117.333 46.6665 115.333 46.6665 113.333 46.6665H46.6667C44.6667 46.6665 43.3334 46.6663 41.3334 47.333C24 49.333 13.3334 61.9998 13.3334 79.9998C13.3334 81.9998 13.3334 84.6665 13.3334 86.6665" stroke="#DADADA" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                    <path opacity="0.4" d="M113.328 46.6681H46.6615C44.6615 46.6681 43.3281 46.668 41.3281 47.3346C41.9948 45.3346 43.3282 44.0014 45.3282 42.0014L66.6615 20.0015C75.9948 10.6681 90.6615 10.6681 99.9948 20.0015L111.995 32.0014C115.995 36.0014 117.995 41.3348 118.661 46.6681C117.328 46.6681 115.328 46.6681 113.328 46.6681Z" stroke="#DADADA" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                    <path opacity="0.4" d="M146.667 83.3335H126.667C119.333 83.3335 113.333 89.3335 113.333 96.6668C113.333 104 119.333 110 126.667 110H146.667" stroke="#DADADA" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M59.9974 121.333C59.9974 109.533 50.4641 100 38.6641 100C26.8641 100 17.3307 109.533 17.3307 121.333C17.3307 133.133 26.8641 142.667 38.6641 142.667C50.4641 142.667 59.9974 133.133 59.9974 121.333Z" stroke="#DADADA" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M13.3334 146.667L20 140" stroke="#DADADA" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>

                <p class="block-no-result__text">{{__('web_wallets_No result')}}</p>
            </div>
        </div>

        <div v-else class="block-loading">
            <div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
            <p class="block-loading__text">{{__('Loading')}}</p>
        </div>


        <ModalDefault width="670" v-if="dialog" v-bind:modal_cancel.sync="dialog">
            <div class="tip-create-ticket" v-if="open_id">
                <p class="tip-create-ticket__title">{{__('web_modal_tip_create_ticket_title')}}</p>

                <p class="tip-create-ticket__subtitle">{{__('web_modal_tip_create_ticket_subtitle')}}</p>

                <div class="block-btns">
                    <v-btn class="btn-white" v-on:click="dialog=false">{{__('web_btn_cancel')}}</v-btn>
                    <router-link :to="{'name': 'ticket', params: {'id': open_id}}" class="btn-site">{{__('web_btn_go_to_ticket')}}</router-link>
                </div>
            </div>
            <div class="modal-create-ticket" v-else>
                <div class="top">
                    <p class="modal-create-ticket__title">Сontact support</p>
                    <p class="desc">Transfiguration lion prince minister werewolf banquet nearly-headless hippogriff. You-know-who nagini.</p>
                    <v-btn class="btn-close" v-ripple="false" text v-on:click="dialog = false">
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M3.71209 3.71209C4.0782 3.34597 4.6718 3.34597 5.03791 3.71209L10 8.67418L14.9621 3.71209C15.3282 3.34597 15.9218 3.34597 16.2879 3.71209C16.654 4.0782 16.654 4.6718 16.2879 5.03791L11.3258 10L16.2879 14.9621C16.654 15.3282 16.654 15.9218 16.2879 16.2879C15.9218 16.654 15.3282 16.654 14.9621 16.2879L10 11.3258L5.03791 16.2879C4.6718 16.654 4.0782 16.654 3.71209 16.2879C3.34597 15.9218 3.34597 15.3282 3.71209 14.9621L8.67418 10L3.71209 5.03791C3.34597 4.6718 3.34597 4.0782 3.71209 3.71209Z" fill="#999999"/>
                        </svg>
                    </v-btn>
                </div>

                <div class="wrap-input">

                    <InputLabelTextDefault
                            :placeholder="__('Topic')"
                            v-model="form.title"
                            v-bind:errors="formValidate.title"
                            @change="updateValidate('title')"
                    ></InputLabelTextDefault>
                </div>

<!--                <div class="wrap-input">-->
<!--                    <p class="wrap-input__label">{{__('web_input_label_departments')}}</p>-->

<!--                    <DropdownDefault-->
<!--                            v-bind:items="tickets_category"-->
<!--                            value_key="name"-->
<!--                            text="name"-->
<!--                            v-model="form.subject"-->
<!--                            :placeholder="__('web_input_placeholder_department')"-->
<!--                            dropSlot-->
<!--                    >-->
<!--                        <template v-slot:selection="item">-->
<!--                            {{__(item.name)}}-->
<!--                        </template>-->
<!--                        <template v-slot:item="item">-->
<!--                            {{__(item.name)}}-->
<!--                        </template>-->
<!--                    </DropdownDefault>-->
<!--                </div>-->

                <div class="wrap-input wrap-input-text">
<!--                    <p class="wrap-input__label">{{__('web_input_label_details')}}</p>-->
                    <InputLabelTextDefault
                        type="textarea"
                        :placeholder="__('web_input_placeholder_enter_ticket_details')"
                        v-model="form.description"
                        v-bind:errors="formValidate.description"
                        @change="updateValidate('description')"
                    >
                    </InputLabelTextDefault>
                    <div class="block-btns">
                        <v-btn class="btn-ticket" v-on:click="onSubmit" v-on:loading="submitDisabled">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <path d="M18.447 3.06295L5.33394 6.34096C2.20094 7.12396 2.23193 11.588 5.37593 12.328L9.45503 13.288C9.55603 13.312 9.66303 13.282 9.73603 13.208L14.4741 8.46996C14.7641 8.17996 15.2439 8.17996 15.5339 8.46996C15.8239 8.75996 15.8239 9.23996 15.5339 9.52996L10.7939 14.2699C10.7209 14.3429 10.6901 14.45 10.7141 14.551L11.673 18.626C12.413 21.77 16.8769 21.801 17.6599 18.668L20.9379 5.55495C21.3129 4.04895 19.95 2.68695 18.447 3.06295Z" fill="#98A2B3"/>
                            </svg>
                        </v-btn>
                    </div>
                </div>


            </div>
        </ModalDefault>
    </div>
</template>

<script>
    import ItemTicket from "./Support/ItemTicket";
    import ModalDefault from "../modules/ModalDefault";
    // import DropdownDefault from "../modules/DropdownDefault";
    import InputLabelTextDefault from "../modules/InputLabelTextDefault";
    import {required} from "vuelidate/lib/validators";
    // import DotLoader from 'vue-spinner/src/DotLoader.vue';
    export default {
        name: 'support',
        data: function() {
            return {
                type: null,
                open_id: null,
                tickets: false,
                tickets_category: false,
                dialog: false,
                form: {
                    title: null,
                    subject: null,
                    description: null,
                },
                formValidate: {
                    title: null,
                    // subject: null,
                    description: null,
                },
                submitDisabled: false,
                loadingPage: false,
                next_page_url: null,
            }
        },
        watch: {

        },

        validations: {
            form: {
                title: {
                    required
                },
                // subject: {
                //     required
                // },
                description: {
                    required
                },
            }
        },
        created() {
            this.getTickets();
            this.$addListener(window,'scroll', () => {
                this.onScrollList();
            });
        },
        methods: {
            changeTab(tab) {
                if(this.tab != tab.type -1) {
                    this.tab= tab.type -1;
                    this.type= tab.value;
                    this.getTickets();
                }
            },
            getTickets() {
                let response= {
                    type: this.type,
                };

                this.$http[(process.env.NODE_ENV === 'production') ? 'post' : 'get']('ajax/tickets', response)
                    .then(response=> {
                        return response.json()
                    })
                    .then((response) => {
                        this.$store.dispatch('asyncResp', response.resp_tickets);
                        response = response.data;

                        this.tickets = response.tickets;
                        this.next_page_url = response.tickets.next_page_url;
                        this.open_id = response.open_id;
                        this.tickets_category = response.tickets_category;
                        this.form.subject = response.tickets_category[0].name;
                    }).catch((err) => {
                    this.httpHandler(err);
                });
            },
            onScrollList() {
                const progress = document.documentElement.scrollTop / (document.documentElement.scrollHeight - document.documentElement.clientHeight);
                if (!this.loadingPage && this.next_page_url) {
                    let bottomOfWindow = 0.7 <= progress;
                    if (bottomOfWindow) {
                        this.loadingPage = true;
                        const request = {
                            type: this.type,
                        };
                        this.$http[(process.env.NODE_ENV === 'production') ? 'post' : 'get'](this.next_page_url, request)

                        .then((response) => {
                            return response.json();
                        })
                        .then((response) => {
                            response = response.data;

                            let tickets = this.$cleanObject(this.tickets);
                            tickets.data = tickets.data.concat(response.tickets.data);
                            this.next_page_url = response.tickets.next_page_url;
                            this.tickets = tickets;
                        })
                        .catch((err) => {
                            this.httpHandler(err);
                            this.loadingPage = false;
                        });
                    }
                }
            },
            updateValidate: function(type, validate= false, key= 'form') {
                if(validate) {
                    let formValidate= this.formValidate;
                    formValidate[type]= [];

                    if(!this.$v.form[type][validate]) {
                        let msg= this.__(this.$validateMessage[validate]);
                        formValidate[type].push(msg);

                    }

                    this.formValidate= formValidate;
                } else {
                    this.formValidate= this.$changeValidate(this.formValidate, this.$v[key][type], type);
                }
            },
            onSubmit: function () {
                let valid = this.$v.form;

                if (valid.$invalid) {
                    let massages = {
                        'title': [],
                        // 'subject': [],
                        'description': []
                    };
                    this.formValidate = this.$formValidate(massages, valid);
                } else {
                    this.submitDisabled= true;
                    let response= this.form;

                    this.$http[(process.env.NODE_ENV === 'production') ? 'post' : 'get']('ajax/tickets/create', response)
                        .then(response=> {
                            return response.json()
                        })
                        .then((response) => {
                            this.$store.dispatch('asyncResp', response.resp_tickets);
                            response = response.data;

                            this.dialog= false;
                            this.$router.push({name: 'ticket', params: {
                                    id: response.id
                                }});
                        }).catch(err => {
                        this.submitDisabled= false;
                        let response= this.httpHandler(err);
                        if(response.error) {
                            this.formValidate = response.error.message;
                        }
                    });
                }
            }
        },
        computed: {

        },
        mounted() {

        },
        components: {
            ItemTicket,
            // DropdownDefault,
            InputLabelTextDefault,
            ModalDefault,
            // DotLoader,
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
